import {post} from './';

export const sendOTP = (body) => {
  const url = '/api/sms/send-code'
  return post(url, body)
}

export const checkOTP = (body) => {
  const url = '/api/sms/check-code'
  return post(url, body)
}
